"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var sis_radio_settings_component_1 = require("./sis-radio-settings.component");
var sis_control_with_settings_1 = require("../../sis-control-with-settings");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
require("./sis-radio.component.scss");
var SisRadioComponent = /** @class */ (function (_super) {
    __extends(SisRadioComponent, _super);
    function SisRadioComponent(classifierService) {
        var _this = _super.call(this) || this;
        _this.classifierService = classifierService;
        _this.items = [];
        _this.disabled = false;
        _this.onClick = new core_1.EventEmitter();
        _this.isReadonly = false;
        _this.destroySubject$ = new Subject_1.Subject();
        return _this;
    }
    SisRadioComponent.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    Object.defineProperty(SisRadioComponent.prototype, "checked", {
        set: function (value) {
            this.checkedItem = value;
        },
        enumerable: true,
        configurable: true
    });
    SisRadioComponent.prototype.findItemById = function () {
        var _this = this;
        if (!this.checkedItem) {
            return undefined;
        }
        return this.items.find(function (item) { return item.getId() === _this.checkedItem.getId(); });
    };
    SisRadioComponent.prototype.getIsReadonly = function () {
        return this.isReadonly;
    };
    SisRadioComponent.prototype.emitClick = function (item) {
        var _this = this;
        if (!this.disabled) {
            this.classifierService
                .loadClassifier(this.fieldCategory, item.id)
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (value) {
                _this.onClick.emit(value);
                _this.checkedItem = value;
            }, console.error);
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisRadioComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisRadioComponent.prototype, "items", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisRadioComponent.prototype, "fieldCategory", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisRadioComponent.prototype, "disabled", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisRadioComponent.prototype, "onClick", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisRadioComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_classifier_service_client_js_1.Classifier),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.Classifier])
    ], SisRadioComponent.prototype, "checked", null);
    SisRadioComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-radio',
            template: require('./sis-radio.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            cellCount: 3,
            groups: [{ identity: 'input', name: 'Input Elements' }],
            iconInfo: 'fa-dot-circle-o',
            name: 'Radio Button',
            nameKey: 'de.controls.radio_button.title',
            settings: {
                main: sis_radio_settings_component_1.SisRadioSettingsComponent,
            },
            template: "\n                        <sis-radio [id]=\"'%{id}'\"\n                                   [items]=\"%{dataItems}\"\n                                   [checked]=\"%{checkedItem}\"\n                                   (onClick)=\"contextEntity.getProperty('%{checkedItem-name}').value = $event\"\n                                   [isReadonly]=\"%{isReadonly}\"\n                                   [fieldCategory]=\"'%{checkedItem-category}'\"\n                                   [hint]=\"%{hint}\"\n                                   [disabled]=\"%{disabled}\">\n                        </sis-radio>\n                        ",
            defaultActions: {
                'dataItems': 'loadClassifiers',
            },
        }),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService])
    ], SisRadioComponent);
    return SisRadioComponent;
}(sis_control_with_settings_1.SisControlWithSettings));
exports.SisRadioComponent = SisRadioComponent;
//# sourceMappingURL=sis-radio.component.js.map